import { render } from "./BalanceItem.vue?vue&type=template&id=4b0bfd43&scoped=true"
import script from "./BalanceItem.vue?vue&type=script&lang=ts"
export * from "./BalanceItem.vue?vue&type=script&lang=ts"

import "./BalanceItem.vue?vue&type=style&index=0&id=4b0bfd43&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-4b0bfd43"

export default script